import React, { useState } from 'react';
import './login.style.scss';
import lgoLogo from '../../../assets/SVG/LGO.svg';
import { useNavigate } from "react-router-dom";
import { jwtDecode } from 'jwt-decode';

const Login = ({ onLogin }) => {
     const [email, setEmail] = useState('');
     const [password, setPassword] = useState('');
     const [error, setError] = useState(null);
     const navigate = useNavigate();

     const handleSubmit = async (e) => {
          e.preventDefault();
      
          if (!email || !password) {
              setError("Please fill in both fields.");
              return;
          }
      
          try {
              const response = await fetch('https://www.lgfantasy.ca/Citations/PHP/login.php', {
                  method: "POST",
                  headers: {
                      "Content-Type": "application/json"
                  },
                  body: JSON.stringify({ email, password })
              });
              const data = await response.json(); // 👈 parse the actual body
              if (data.status === 'success') {
               const decoded = jwtDecode(data.token);
                  localStorage.setItem('LGOUser', data.token);
                  if (decoded.security === 'Client') {
                      navigate('/clientDashboard');
                  } else {
                      navigate('/dashboard');
                  }
              } else {
                  setError("Login failed. Please check your credentials.");
              }
      
          } catch (err) {
              console.error(err);
              setError("An error occurred. Please try again later.");
          }
      };
      

     const forgotMyPass = () => {
          alert('Forgot Password coming online shortly')
     }

     return (
          <div className="login-container bg-dark d-flex flex-column align-items-center justify-content-center" style={{ minHeight: "100vh" }}>
               <img src={lgoLogo} height="80px" alt="" className="mb-4" />
               <div className="text-center h3 text-lemon fw-bold">Client Portal</div>
               <form className="login-form w-100" style={{ maxWidth: 400 }} onSubmit={handleSubmit}>
                    {error && <div className="alert alert-danger">{error}</div>}
                    <div className="form-group mb-2">
                         <div className="h3 text-light text-center">Log In</div>
                    </div>
                    <div className="form-group mb-3">
                         <label className='text-light'>Email</label>
                         <input
                              type="email"
                              className="form-control"
                              value={email}
                              onChange={(e) => setEmail(e.target.value)}
                              autoComplete="email"
                         />
                    </div>
                    <div className="form-group mb-4">
                         <label className='text-light'>Password</label>
                         <input
                              type="password"
                              className="form-control"
                              value={password}
                              onChange={(e) => setPassword(e.target.value)}
                              autoComplete="current-password"
                         />
                    </div>
                    <button type="submit" className="btn btn-warning w-100 mb-2">
                         Log In
                    </button>
                    <div className="forgot text-center" style={{ cursor: "pointer" }} onClick={forgotMyPass}>
                         Forgot Your Password?
                    </div>
               </form>
          </div>
     );
};

export default Login;
